import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { QuotesEvent, useTrackQuotesEvent } from './quotesAnalytics'

interface CargoRestrictionDialogProps {
  /** e.g. "Only applies to certain trucks." */
  note: string
  affectedTrucks: string[]
}

/** "View list" trigger for a coverage restriction note — generic over coverage type. */
export function CargoRestrictionDialog({ note, affectedTrucks }: CargoRestrictionDialogProps) {
  const track = useTrackQuotesEvent()

  return (
    <Dialog
      onOpenChange={(open) =>
        open && track(QuotesEvent.CARD_RESTRICTIONS_OPENED, { affected_count: affectedTrucks.length })
      }
    >
      <DialogTrigger asChild>
        <Button
          variant="link"
          className="text-brand-700 hover:text-brand-800 h-auto p-0 text-xs font-medium underline underline-offset-2"
        >
          View list
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Affected trucks</DialogTitle>
          <DialogDescription>{note}</DialogDescription>
        </DialogHeader>
        <ul className="text-md flex flex-col gap-2">
          {affectedTrucks.map((truck) => (
            <li key={truck} className="border-ink-100 border-b pb-2 last:border-b-0 last:pb-0">
              {truck}
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  )
}
